import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { SPECIALFUNCUW_INIT_LOADING, SPECIALFUNCUW_INIT_SUCCESS, SPECIALFUNCUW_INIT_FAIL,
  RISK_SURVEY_INIT_LOADING, RISK_SURVEY_INIT_SUCCESS, RISK_SURVEY_INIT_FAIL,
  RISK_SURVEY_MASTER, RISK_SURVEY_DETAILS, RESET_RISK_SURVEY_MASTER,
  RESET_RISK_SURVEY_DETAILS } from '@/store/types'

export const specialFuncUW = {
  async specialFuncUWInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.specialFuncUW
    commit(SPECIALFUNCUW_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(SPECIALFUNCUW_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(SPECIALFUNCUW_INIT_FAIL, extractMessages(error))
    }
  },
  async riskSurveyHeader({ commit, rootState }, data) {
    commit(RISK_SURVEY_MASTER, data)
  },
  async riskSurveyInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.specialFuncUW
    commit(RISK_SURVEY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const apiUrl2 = menu.initRiskSurvey
      if (apiUrl2) {
        const result2 = await http.get(apiUrl2)
        const menu2 = extractMenu(result2.data._links)
        const commitResult = {
          menu: menu2
        }
        commit(RISK_SURVEY_INIT_SUCCESS, commitResult)
      }
    } catch (error) {
      commit(RISK_SURVEY_INIT_FAIL, extractMessages(error))
    }
  },
  async reviewSurveyMaster({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.menu.specialFuncUW
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const apiUrl2 = menu.initRiskSurvey
        if (apiUrl2) {
          const result2 = await http.get(apiUrl2)
          const menu2 = extractMenu(result2.data._links)
          const apiUrl3 = menu2.getRiskSurvey
          if (apiUrl3) {
            const expand = {
              survNo: formData.item.survNo,
              verCnt: formData.item.verCnt,
              polNo: formData.item.polNo
            }
            const result3 = await http.post(apiUrl3, expand)
            if (result3.data) {
              const commitObject = result3.data.data.survMaster
              commit(RISK_SURVEY_MASTER, commitObject)
              return true
            } else {
              throw new Error('Invalid Fetch Result')
            }
          }
          return false
        }
      } catch (err) {
        throw err
      }
    } else {
      throw new Error('The request failed because it is trying to execute an invalid API url.')
    }
  },
  async reviewSurveyDetails({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.menu.specialFuncUW
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const apiUrl2 = menu.initRiskSurvey
        if (apiUrl2) {
          const result2 = await http.get(apiUrl2)
          const menu2 = extractMenu(result2.data._links)
          const apiUrl3 = menu2.getRiskSurveyDet
          if (apiUrl3) {
            const expand = {
              survNo: formData.item.survNo,
              verCnt: formData.item.verCnt
            }
            const result3 = await http.get(expandURI(apiUrl3, expand))
            if (result3.data) {
              const commitObject = result3.data.data.survDet
              commit(RISK_SURVEY_DETAILS, commitObject)
              return true
            }
          }
          return false
        }
      } catch (err) {
        throw err
      }
    } else {
      throw new Error('The request failed because it is trying to execute an invalid API url.')
    }
  },
  async storeSurveyMaster({ commit, rootState }, data) {
    commit(RISK_SURVEY_MASTER, data)
  },
  async storeSurveyDetails({ commit, rootState }, data) {
    commit(RISK_SURVEY_DETAILS, data)
  },
  async resetSurveyMaster({ commit, rootState }, data) {
    commit(RESET_RISK_SURVEY_MASTER)
  },
  async resetSurveyDetails({ commit, rootState }, data) {
    commit(RESET_RISK_SURVEY_DETAILS)
  }
}
